import { Compass } from 'lucide-react';
import { Box, Button, Heading, Stack, Text } from 'pixelize-design-library';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { useAppTheme } from '@core/Theme/useAppTheme';
import { canvas, mutedText, surface } from '@core/Theme/tokens';
import { homePathForRole } from '@core/utils/roleHome';
import { useAppSelector } from '@core/store/hooks';

/** The `path="*"` screen. An unknown URL is not a crash — it needs a way onward, not a retry. */
export function NotFoundPage() {
  const navigate = useNavigate();
  const { colors } = useAppTheme();
  const { t } = useTranslation();
  const role = useAppSelector((s) => s.auth.user?.role);

  return (
    <Box
      minH='60vh'
      display='flex'
      alignItems='center'
      justifyContent='center'
      bg={canvas(colors)}
      p={6}
    >
      <Stack
        spacing={4}
        align='center'
        textAlign='center'
        maxW='md'
        bg={surface(colors)}
        borderRadius='xl'
        borderWidth='1px'
        borderColor={colors.boxborder[200]}
        p={8}
        data-testid='not-found-page'
      >
        <Compass size={40} color={colors.accentText} />
        <Heading size='md' color={colors.header[900]}>
          {t('errorPage.notFoundTitle')}
        </Heading>
        <Text fontSize='sm' color={mutedText(colors)}>
          {t('errorPage.notFoundBody')}
        </Text>
        <Button
          label={t('errorPage.goToDashboard')}
          colorScheme='primary'
          onClick={() => navigate(homePathForRole(role))}
          data-testid='not-found-home'
        />
      </Stack>
    </Box>
  );
}
